// libraries.
import { ModelError } from '../../interfaces/interfaces';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiApproverPortal } from '../../redux/apiSlices/apiSlices';

// interfaces.
interface DomainApprovalParams {
  country?: string;
  nid: string;
}

const is_dev = false;
const generate_error = false;

export const domainApproval = apiApproverPortal.injectEndpoints({
  endpoints: builder => ({
    getDomainApproval: builder.query({
      query: ({ country, nid }: DomainApprovalParams) => {
        return `/domain_approval?country=${country}&nid=${nid}&is_dev=${is_dev}&generate_error=${generate_error}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getDomainApproval',
        };
        return modelError;
      },
      transformResponse: response => {
        return response;
      },
    }),
  }),
});

export const { useGetDomainApprovalQuery, useLazyGetDomainApprovalQuery } =
  domainApproval;
